import React from "react";

function PersonIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="18"
            fill="none"
            viewBox="0 0 16 18"
        >
            <path
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8 9.833A4.167 4.167 0 108 1.5a4.167 4.167 0 000 8.333zM14.667 16.5a6.667 6.667 0 00-13.334 0"
            ></path>
        </svg>
    );
}

export default PersonIcon;
